import pick from 'lodash/pick';

import { digestArtifactContexts } from '../digestArtifactContexts';

import type { EventDefinition } from '../../types';

// `digest_story_add` 1-0-0 (klue-snowplow #218): a curator tries to put a
// story into an Intel Digest 2.0 issue, by picking one Klue already holds or
// by pasting a URL. One event per attempt, successful or not.
//
// The schema has no `action` property — `method` (which door) and `outcome`
// (what it produced) carry the meaning, and both are required, which is the
// whole reason this is its own event. The tracker still needs a category and
// action pair, so the action is accepted and dropped here.
//
// The issue always rides an `artifact` entity; the story attaches a second
// one whenever its id is known, including on a failure that still returned
// one.
export const digest_story_add: EventDefinition = {
  getData: (_, eventData = {}) =>
    pick(eventData, ['method', 'outcome', 'failure_reason']),
  addContexts: digestArtifactContexts,
};
